import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";

const CustomDataTable = ({
  data = [],
  columns = [],
  onRowClick = () => {},
  pagination = true,
  rowsPerPageOptions = [10, 20, 50,80,100],
  rows = 10,
  className = "p-datatable-striped",
  compact = false, // If true, apply compact row styling
  selection = [],
  onSelectionChange = () => {},
}) => {
  const history = useNavigate();

  return (
    <DataTable
      value={data}
      paginator={pagination}
      rows={rows}
      rowsPerPageOptions={rowsPerPageOptions}
      className={`${className} custom-datatable`}
      rowClassName={() => (compact ? "compact-row" : "")} // Apply compact style if needed
      onRowClick={(event) => onRowClick(event.data)}
      style={{ cursor: "pointer", minHeight: "300px" }} // Set table min-height
      selectionMode="checkbox" // Enable checkbox selection
      selection={selection} // Bind selected rows to parent state
      onSelectionChange={(e) => onSelectionChange(e.value)} // Pass the selected rows to parent
    >
      {columns.map((col, index) => (
        <Column
          key={index}
          field={col.field}
          header={col.header}
          sortable={col.sortable || false}
          body={col.body ? (rowData) => col.body(rowData, history) : null}
          headerStyle={{ ...col.headerStyle }}
          bodyStyle={{ ...col.bodyStyle, minHeight: "40px", height: "40px" }} // Ensure row height is fixed
        />
      ))}
    </DataTable>
  );
};

export default CustomDataTable;
